/* eslint-disable */ import * as types from "./graphql";
/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel-plugin for production.
 */ const documents = {
    "\n  query FeatureFlagsQuery(\n    $contextKind: String\n    $userKey: String\n    $attributes: FeatureFlagVariationsAttributes\n  ) {\n    featureFlagVariationDetails(\n      contextKind: $contextKind\n      userKey: $userKey\n      attributes: $attributes\n    ) {\n      flagKey\n      flagValue\n      userKey\n    }\n  }\n": types.FeatureFlagsQueryDocument
};
export function graphql(source) {
    return documents[source] ?? {};
}
